import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ApplicationInsightsService } from '../../application-insights.service';

@Injectable({
  providedIn: 'root',
})
export class TeamMemberGuard {
  constructor(
    private router: Router,
    private applicationInsightsService: ApplicationInsightsService,
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let id = +next.url[1].path;
    if (isNaN(id) || id < 0) {
      this.applicationInsightsService.logTrace('Invalid Parameter passed as MemberId: ' + id);
      this.router.navigate(['/team']);
      return false;
    }
    return true;
  }
}
